export default __webpack_public_path__ + "static/media/HeavenlyWriting.f5e6aa8f.png";